/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Fragment } from 'react';
import { Link } from 'react-router-dom';



export default function SignedOutLink() {
  return (
    <Fragment>
      <li>
        <Link to='/signup'>РЕГИСТРАЦИЯ</Link>
      </li>
      <li>
        <Link to='/signin'>ВОЙТИ</Link>
      </li>
    </Fragment>

  )
}


